import { logger } from '@/shared/logging';

export const formLogger = logger('provider.FormProvider');
